import { Directive, OnInit, ElementRef, Renderer2, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

/**
 * Utility method used for set active class to language button
 */
@Directive({
  selector: '[apActiveMenu]',
})
export class ActiveMenuDirective implements OnInit, OnChanges {
  @Input() apActiveMenu?: string;

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2, private readonly translateService: TranslateService) { }

  /**
   * Component initialization. Update current active language button based on current language used
   */
  ngOnInit(): void {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateActiveFlag(event.lang);
    });

    this.updateActiveFlag(this.translateService.currentLang);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['apActiveMenu']) {
      this.updateActiveFlag(this.translateService.currentLang);
    }
  }

  /**
   * Add class 'active' to language selected by user
   * @param selectedLanguage the current language selected
   */
  updateActiveFlag(selectedLanguage: string): void {
    if (this.apActiveMenu === selectedLanguage) {
      this.renderer.addClass(this.el.nativeElement, 'active');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'active');
    }
  }
}
